import { baseApi } from 'services'

import { DocumentTemplate } from '@/types/unlock'

export const documentTemplateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listDocumentTemplates: builder.query<
      DocumentTemplate[],
      {
        source?: string
        type?: string
        category?: string
        is_requested_document?: boolean
      }
    >({
      query: ({ source, type, category, is_requested_document }) => {
        return {
          url: 'v2/document-template/',
          method: 'GET',
          params: {
            source: source || '',
            type: type || '',
            category: category || '',
            is_requested_document: is_requested_document || null,
          },
        }
      },
      providesTags: ['DocumentTemplate'],
    }),
    getDocumentTemplateById: builder.query<DocumentTemplate, string | string[]>({
      query: (id) => `v2/document-template/${id}/`,
      providesTags: () => ['DocumentTemplate'],
    }),
    updateDocumentTemplate: builder.mutation<DocumentTemplate, Partial<DocumentTemplate>>({
      query: (documentTemplate) => ({
        url: `v2/document-template/${documentTemplate.id}/`,
        method: 'PATCH',
        body: documentTemplate,
      }),
      invalidatesTags: ['DocumentTemplate', 'Documents'],
    }),
    createDocumentTemplate: builder.mutation<DocumentTemplate, Partial<DocumentTemplate>>({
      query: (documentTemplate) => ({
        url: `v2/document-template/`,
        method: 'POST',
        body: documentTemplate,
      }),
      invalidatesTags: ['DocumentTemplate', 'Documents'],
    }),
    deleteDocumentTemplate: builder.mutation<DocumentTemplate, string>({
      query: (id) => ({
        url: `v2/document-template/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DocumentTemplate', 'Documents'],
    }),
  }),
})

export const {
  useCreateDocumentTemplateMutation,
  useDeleteDocumentTemplateMutation,
  useGetDocumentTemplateByIdQuery,
  useListDocumentTemplatesQuery,
  useUpdateDocumentTemplateMutation,
} = documentTemplateApi
